import React from 'react';

type Props = { children: React.ReactNode };
type State = { error?: Error; info?: React.ErrorInfo };

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = {};
  
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.group('%c[ErrorBoundary]', 'color:red;font-weight:bold;');
    console.error('Error:', error);
    console.log('Component Stack:\n', info.componentStack);
    console.log('Error Stack:', error.stack);
    console.groupEnd();
    this.setState({ error, info });
  }
  
  render() {
    if (this.state.error) {
      return (
        <div className="p-6 m-4 border-2 border-red-500 bg-red-50 rounded-lg">
          <h3 className="text-xl font-bold text-red-700 mb-2">Błąd renderowania</h3>
          <div className="bg-white p-4 rounded border border-red-200">
            <h4 className="font-semibold text-red-600 mb-2">Błąd:</h4>
            <pre className="text-sm overflow-auto">{String(this.state.error)}</pre>
            <h4 className="font-semibold text-red-600 mt-4 mb-2">Stack:</h4>
            <pre className="text-xs overflow-auto">{this.state.error?.stack}</pre>
            <h4 className="font-semibold text-red-600 mt-4 mb-2">Component Stack:</h4>
            <pre className="text-xs overflow-auto">{this.state.info?.componentStack}</pre>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
